import { Filters } from "../types"

export const notificationsQueryKeys = {
  all: ["notifications"] as const,
  filters: (filters: Filters) =>
    [...notificationsQueryKeys.all, filters] as const,
  count: () => [...notificationsQueryKeys.all, "count"] as const,
}
